// @ai-generated 2026-08-26T13:23:32+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { IconAlertTriangle, IconCircleCheck, IconInfoCircle } from '@tabler/icons-react';
import { type MessageVariant } from './messageVariant';
import styles from './MessageLevelIcon.module.css';

const ICONS_BY_VARIANT: Record<MessageVariant, typeof IconInfoCircle> = {
    info: IconInfoCircle,
    success: IconCircleCheck,
    warning: IconAlertTriangle,
    error: IconAlertTriangle,
};

const ICON_PIXELS: Record<MessageLevelIconSize, number> = {
    md: 18,
    sm: 14,
};

type MessageLevelIconSize = 'sm' | 'md';

interface MessageLevelIconProps {
    variant: MessageVariant;
    /** `md` for a notification row, `sm` where a message is one line among many. */
    size?: MessageLevelIconSize;
}

/**
 * A message's level as the tinted badge the notification hub shows it as: the same icon and the same
 * colours wherever a message is rendered, so a user recognises the thing they were notified about.
 */
export function MessageLevelIcon({ variant, size = 'md' }: MessageLevelIconProps) {
    const Icon = ICONS_BY_VARIANT[variant];

    return (
        <div className={styles.wrap} data-variant={variant} data-size={size}>
            <Icon className={styles.icon} data-variant={variant} size={ICON_PIXELS[size]} />
        </div>
    );
}
